const browserEnv =
  typeof window !== "undefined" && window._env_ ? window._env_ : {};

const mergedEnv = {
  ...process.env,
  ...browserEnv,
};

function pickFirst(...values) {
  return values.find((value) => String(value ?? "").trim() !== "") || "";
}

function resolveAdminPort(env) {
  const envKey = String(env.REACT_APP_ENV || "").trim().toLowerCase();

  if (envKey === "local") {
    return pickFirst(
      env.REACT_APP_ADMIN_PORT_LOCAL,
      env.REACT_ADMIN_PORT_LOCAL,
      env.REACT_ADMIN_PORT,
      env.REACT_APP_ADMIN_PORT,
    );
  }

  if (envKey === "development") {
    return pickFirst(
      env.REACT_APP_ADMIN_PORT_DEV,
      env.REACT_APP_ADMIN_PORT_DEVELOP,
      env.REACT_ADMIN_PORT_DEV,
      env.REACT_ADMIN_PORT_DEVELOP,
      env.REACT_ADMIN_PORT,
      env.REACT_APP_ADMIN_PORT,
    );
  }

  if (envKey === "test") {
    return pickFirst(
      env.REACT_APP_ADMIN_PORT_TEST,
      env.REACT_ADMIN_PORT_TEST,
      env.REACT_ADMIN_PORT,
      env.REACT_APP_ADMIN_PORT,
    );
  }

  return pickFirst(env.REACT_ADMIN_PORT, env.REACT_APP_ADMIN_PORT);
}

const adminPort = resolveAdminPort(mergedEnv);

export const runtimeEnv = {
  ...mergedEnv,
  REACT_ADMIN_PORT: adminPort,
  REACT_APP_ADMIN_PORT: adminPort,
};
